import React from 'react';
import './about.css';

const About = () => {
  return (
    <div className="about-us-container">
      <section className="intro-section">
        <div className="intro-text">
          <h1 className="intro-heading">About Us</h1>
          <p className="intro-description">
            Welcome to Southzone Industrial Lubricants, your trusted partner in high-quality industrial oils and
            grease. With a commitment to excellence, we specialize in providing top-tier lubrication
            solutions designed to enhance performance, protect equipment, and extend the lifespan of
            machinery across a wide range of industries. From heavy-duty manufacturing to precision
            machinery, our extensive product range includes synthetic oils, hydraulic fluids, gear oils, cutting
            fluids, and more — all formulated to meet the most demanding industrial standards.
            <br />
            <br />
            At Southzone ILS, we pride ourselves on our expertise, reliability, and customer-centric
            approach. Whether you're looking for customized solutions or off-the-shelf products, our team of
            professionals is dedicated to helping you optimize efficiency and reduce downtime. Explore our
            offerings today and discover how our lubricants can keep your operations running smoothly and
            efficiently.
          </p>
        </div>
      </section>

      <section className="achievements-section">
        <div className="achievements-row">
          <div className="achievement-card">
            <h3>200+ Products</h3>
            <p>Providing a wide range of lubricant solutions tailored to your needs.</p>
          </div>
          <div className="achievement-card">
            <h3>Delivering 200+ Industries</h3>
            <p>We have Products for every Industry</p>
          </div>
          <div className="achievement-card">
            <h3>100% Guaranteed Genuine Products</h3>
            <p>We take pride in Ensuring the Quality and Genuineness of our Product</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
